import { create } from "zustand";
import { FilterStateType } from "../types";

type FilterType = Pick<FilterStateType, 
    "date_start"        | 
    "date_end"          | 
    "type"              | 
    "keyword"           | 
    "divisi"            | 
    "shift_schedule_id" | 
    "department"        |
    "shift_schedule_code"
>;

type FilterStore = {
  filter: FilterType;
  setFilter: (partial: Partial<FilterType>) => void;
  resetFilter: () => void;
};

const defaultFilter: FilterType = {
  date_start: "",
  date_end: "",
  type: "now",
  keyword: "",
  divisi: "", 
};

export const useListFilter = create<FilterStore>((set) => ({
  filter: defaultFilter,

  setFilter: (partial) =>
    set((state) => ({
      filter: { ...state.filter, ...partial },
    })),

  resetFilter: () => set({ filter: defaultFilter }),
}));


